import React from "react";
import "../../styles/LearningStreams.css";

const LearningStreams = () => {
  const programsData = [
    {
      id: 1,
      theme: "blue",
      title: "Primary (1st – 5th Standard)",
      // Image: Building blocks/Toys representing foundational learning
      icon: "https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=400&q=80",
      points: [
        "Focus on <strong>strong basics</strong> in English, Maths, Science.",
        "Activity-based learning for better understanding.",
        "Tamil & English medium support."
      ]
    },
    {
      id: 2,
      theme: "purple",
      title: "Middle School (6th – 8th Standard)",
      // Image: Stack of books representing subject knowledge
      icon: "https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&w=400&q=80",
      points: [
        "Subject-wise tuition for <strong>Maths, Science, Social Science, English.</strong>",
        "Weekly tests to track performance.",
        "Foundation building for higher classes."
      ]
    },
    {
      id: 3,
      theme: "green",
      title: "High School (9th – 10th Standard)",
      // Image: School supplies/Blackboard context for board exams
      icon: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?auto=format&fit=crop&w=400&q=80",
      points: [
        "<strong>Board exam-oriented preparation</strong> for State Board & CBSE.",
        "Past paper practice & time management skills.",
        "Concept clarity + exam writing skills."
      ]
    },
   {
      id: 4,
      theme: "gold",
      title: "Higher Secondary (11th – 12th Standard)",
      // Image: Graduation Cap representing completion & career focus
      icon: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=400&q=80",
      points: [
        "Special coaching for <strong>Commerce, Science & Maths</strong> streams.",
        "Competitive exam guidance (NEET, JEE, CA Foundation, CMA Foundation).",
        "Career counselling for future studies."
      ]
    }
  ];

  return (
    <section className="programs-section container">
      <h2 className="section-main-title">Our Programs</h2>
      
      <div className="programs-grid">
        {programsData.map((program) => (
          <div key={program.id} className={`program-card card-${program.theme}`}>
            
            {/* Top Icon */}
            <div className="icon-wrapper">
              <img src={program.icon} alt={program.title} className="program-icon" />
            </div>

            {/* Title Bar */}
            <div className="program-title-bar">
              {program.title}
            </div>

            {/* Bullet Points List */}
            <ul className="program-points">
              {program.points.map((point, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: point }}></li>
              ))}
            </ul>

          </div>
        ))}
      </div>
    </section>
  );
};

export default LearningStreams;